import { css } from '@emotion/core'
import * as React from 'react'

import { ctaInlineBreakPoint, longCopyBreakPoint } from '../../constants/breakPoints'
import { breakpoints } from '../../constants/breakPoints'
import { isMobile } from '../../helpers/common'
import { CTAInstantTourProps } from '../../interfaces/cta'
import { Button } from '../Button'
import Image from '../Image'
import { Link } from '../Link'
import { useInstantTourLinkFactory } from '../useTracking'

const CTAInstantTour: React.FunctionComponent<CTAInstantTourProps> = ({ instantTourType }) => {
  const instantTourLink = useInstantTourLinkFactory()(instantTourType)

  return (
    <div className="purple-bg with-box-shadow" css={containerStyle}>
      <div css={contentStyle}>
        <div className="blue-text heading4">Product Walkthrough</div>
        <h3 className="heading3 black-text no-margin">
          See airfocus <br /> in action
        </h3>
        <Button link={instantTourLink} css={buttonStyle}>
          Instant tour
        </Button>
      </div>

      <Link className="scale-on-hover" href={instantTourLink} css={imageStyle}>
        <Image
          src={`cta/${isMobile(breakpoints.small) ? 'demo-small' : 'general'}.webp`}
          alt="airfocus modular platform"
        />
      </Link>
    </div>
  )
}

export default CTAInstantTour

const containerStyle = css`
  margin: 2rem 0;
  border-radius: 0.5rem;
  position: relative;

  @media screen and (max-width: ${breakpoints.small}px) {
    margin-top: 3rem;
  }
`

const contentStyle = css`
  padding: 3rem 0 3rem 3rem;

  @media screen and (max-width: ${breakpoints.xlarge}px) {
    padding: 2rem 0 2rem 3rem;
  }

  @media screen and (max-width: ${ctaInlineBreakPoint}px) and (min-width: ${breakpoints.medium + 1}px) {
    padding: 2rem 0 2rem 2.5rem;
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    padding: 2rem;
  }
`

const buttonStyle = css`
  margin-top: 1.5rem;
`

const imageStyle = css`
  position: absolute;
  width: 400px;
  top: 0;
  right: -8px;

  @media screen and (min-width: ${longCopyBreakPoint + 1}px) and (max-width: ${breakpoints.xlarge}px) {
    right: -105px;
  }

  @media screen and (max-width: ${longCopyBreakPoint}px) {
    width: 60%;
    right: -5px;
  }

  @media screen and (max-width: ${ctaInlineBreakPoint}px) {
    width: 400px;
    top: 5px;
    left: 50%;
  }

  @media screen and (max-width: ${breakpoints.medium}px) {
    width: 370px;
    top: 3%;
    left: initial;
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    width: 8rem;
    top: -3.5rem;
    right: -1rem;
  }
`
